<template>

<div class="uk-child-width-1-3@m uk-grid-small uk-grid-match" uk-grid>
    <div>
        <div class="uk-card uk-card-default uk-card-body">
            <h3 class="uk-card-title">Reptilians</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
            <button class="uk-button uk-button-danger uk-button-large">Uffish Thought</button>
        </div>
    </div>
    <div>
        <div class="uk-card uk-card-primary uk-card-body">
            <h3 class="uk-card-title">Marsupials</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
            <button class="uk-button uk-button-secondary uk-button-large">Uffish Thought</button>
            
        </div>
    </div>
    <div>
        <div class="uk-card uk-card-secondary uk-card-body">
            <h3 class="uk-card-title">Mammals</h3>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit.</p>
            <button class="uk-button uk-button-primary uk-button-large">Uffish Thought</button>
        </div>
    </div>
</div>

</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>